import { EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { AcceptedOfferSynchronizationsTableDefinitionZod } from '../tables/AcceptedOfferSynchronizations';

type Arguments = {
    id: string;
};
export const schemaLoanRequestResolver_GetOffersSynchronizationStatus = z
    .object({
        status: z.nativeEnum(EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES),
        warning: AcceptedOfferSynchronizationsTableDefinitionZod.shape.warning,
    })
    .nullable();

export type SchemaLoanRequestResolver_GetOffersSynchronizationStatus = z.infer<
    typeof schemaLoanRequestResolver_GetOffersSynchronizationStatus
>;

export type LoanRequestResolver_GetOffersSynchronizationStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOffersSynchronizationStatus
>;
